import {
  CANVAS_DEFAULT_FONT_FAMILY,
  audioPlayerStyles,
  phonicPlayerStyles,
} from "@ai-teach/canvas-styles";
import type { PhonicElement } from "@ai-teach/types";
import { Button, IconButton } from "@ai-teach/ui-web";
import { useState } from "react";
import { FaPause, FaPlay } from "react-icons/fa";
import { HiVolumeUp } from "react-icons/hi";

interface PhonicRendererProps {
  element: PhonicElement;
  isLiveMode?: boolean;
}

export function PhonicRenderer({ element }: PhonicRendererProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioRef, setAudioRef] = useState<HTMLAudioElement | null>(null);

  const handlePlayPause = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (audioRef) {
      if (isPlaying) {
        audioRef.pause();
      } else {
        audioRef.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div
      style={{
        ...phonicPlayerStyles.outerDiv,
        pointerEvents: "auto",
        userSelect: "none",
      }}
    >
      <audio
        ref={setAudioRef}
        src={element.media.src ?? ""}
        autoPlay={element.autoPlay}
        loop={element.loop}
        controls={false}
        onEnded={() => setIsPlaying(false)}
      >
        <track kind="captions" />
      </audio>

      <p style={{ ...audioPlayerStyles.text, fontFamily: CANVAS_DEFAULT_FONT_FAMILY }}>
        {element.phoneme}
      </p>

      {/* Play/Pause Button */}
      <button type="button" onClick={handlePlayPause} aria-label={isPlaying ? "Pause" : "Play"}>
        {isPlaying ? (
          <FaPause style={phonicPlayerStyles.playingColor} />
        ) : (
          <FaPlay style={phonicPlayerStyles.playingColor} />
        )}
      </button>
    </div>
  );
}
